export const PROD_DOMAIN = typeof window !== 'undefined' && window?.location?.origin.includes('exchange')
  ? 'https://exchange.homedepot.com'
  : 'https://www.homedepot.com';

export const FEATURE_SWITCHES = Object.freeze({
  useNewMapPolicy: 'fs:pricing--enableNewMapPolicy',
  isPLPMessagingEnabled: 'fs:promotion--plpPromoMessageEnabled'
});
